import React from 'react';
import { styled } from '@mui/material/styles';
import { colors, fontSize } from '../../constants';
import { IconRosetteDiscountCheckFilled } from '@tabler/icons-react';

interface UserNameProps {
  name: string;
  image: string;
  isVerified?: boolean;
  height?: number | string;
  width?: number | string;
  onClick?: () => void;
}

export const CustomAvatar: React.FC<UserNameProps> = ({
  name,
  image,
  isVerified = false,
  height = 32,
  width = 32,
  onClick
}) => (
  <Container onClick={onClick ? () => onClick() : () => null}>
    <AvatarWrapper style={{ height, width }}>
      {image ? (
        <DoctorAvatar src={image} alt={name} />
      ) : (
        <FallbackAvatar style={{ fontSize: isVerified ? fontSize.xlarge : fontSize.medium }}>
          {name.split(' ')[0]?.charAt(0)?.toUpperCase()}
          {''}
          {name.split(' ')[1]?.charAt(0)?.toUpperCase()}
        </FallbackAvatar>
      )}

      {isVerified && (
        <Badge>
          <IconRosetteDiscountCheckFilled size={18} color={colors.blueBase} />
        </Badge>
      )}
    </AvatarWrapper>

    {!isVerified && <NameText>{name}</NameText>}
  </Container>
);

// --- Styled components ---

const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  maxWidth: 250,
  cursor: 'default'
}));

const DoctorAvatar = styled('img')(() => ({
  width: '100%',
  height: '100%',
  borderRadius: '50%',
  objectFit: 'cover'
}));

const FallbackAvatar = styled('div')(() => ({
  width: '100%',
  height: '100%',
  borderRadius: '50%',
  backgroundColor: colors.grayBody,
  color: colors.white,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontWeight: 'bold',
  fontSize: fontSize.medium
}));

const AvatarWrapper = styled('div')(() => ({
  position: 'relative',
  borderRadius: '50%',
  cursor: 'pointer',
  overflow: 'visible' // important!
}));

const Badge = styled('div')(() => ({
  position: 'absolute',
  bottom: 8, // ↓ overlaps half outside
  right: 8, // → overlaps half outside
  backgroundColor: '#fff',
  borderRadius: '50%',
  padding: 3,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  boxShadow: '0 2px 6px rgba(0,0,0,0.25)'
}));

const NameText = styled('span')(() => ({
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  maxWidth: 200,
  display: 'inline-block'
}));
